exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2a549{font-size:.875em;padding:16px;padding:1rem;min-width:100px;display:inline-block;background-color:#6eb658;color:#fff;cursor:pointer;font-weight:500;text-decoration:none;text-transform:uppercase;border-radius:50px}._2a549+._2a549{margin-left:16px;margin-left:1rem}@media screen and (min-width:768px){._2a549{padding:1rem 20px;min-width:160px}}._1gH9y{background-color:#0b91cf}._1OuHi{background-color:#28a44a}.xkH7e{background-color:#ca0921}.SWYQ3{background-color:transparent;color:#0b91cf}", ""]);

// exports
exports.locals = {
	"button": "_2a549",
	"primary": "_1gH9y",
	"yes": "_1OuHi",
	"no": "xkH7e",
	"link": "SWYQ3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Button/Button.css
// module id = 670
// module chunks = 0 2